export class IncidentReport {
    static fromExistingData(report: any): IncidentReport {
        const incidentReport = new IncidentReport();
        if (report.building) incidentReport.buildingId = +report.building.bdId;
        if (report.building) incidentReport.buildingName = report.building.name;
        if (report.building) incidentReport.buildingAddress = report.building.address;
        if (report.createdAt) incidentReport.createdAt = report.createdAt;
        if (report.incidentAt) incidentReport.incidentAt = report.incidentAt;
        if (report.createdBy) incidentReport.createdBy = report.createdBy;
        if (report.id) incidentReport.id = report.id;
        if (report.incident) incidentReport.incident = report.incident;
        if (report.incidentReportNumber) incidentReport.incidentReportNumber = report.incidentReportNumber;
        if (report.incidentReportType) incidentReport.incidentReportType = report.incidentReportType;
        if (report.incidentReportTypeOther) incidentReport.incidentReportTypeOther = report.incidentReportTypeOther;
        if (report.otherResident) incidentReport.otherResident = report.otherResident;
        if (report.otherSuite) incidentReport.otherSuite = report.otherSuite;
        if (report.pathToPdf) incidentReport.pathToPdf = report.pathToPdf;
        if (report.pdfName) incidentReport.pdfName = report.pdfName;
        if (report.reportedArea) incidentReport.reportedArea = report.reportedArea;
        if (report.reportedBy) incidentReport.reportedBy = report.reportedBy;
        if (report.resident) incidentReport.residentId = +report.resident.bdId;
        if (report.resident) incidentReport.residentFullName = report.resident.fullName;
        if (report.suite) incidentReport.suiteId = +report.suite.bdId;
        if (report.suite) incidentReport.suiteNumber = report.suite.suiteNumber;
        if (report.securityCompanyLogo) incidentReport.securityCompanyLogo = report.securityCompanyLogo;
        if (report.attachments) incidentReport.attachments = report.attachments;
        incidentReport.isCanEdit = report.isCanEdit;
        incidentReport.isCanDelete = report.isCanDelete;
        incidentReport.entries = [];
        return incidentReport;
    }

    constructor(
        public id: number = null,
        public suiteId: number = null,
        public suiteNumber: string = '',
        public incident: string = '',
        public incidentReportNumber: string = '',
        public incidentReportType: any = '',
        public returningByName: string = '',
        public buildingId: number = null,
        public buildingName: string = '',
        public buildingAddress: string = '',
        public residentId: number = null,
        public residentFullName: string = '',
        public otherResident: string = '',
        public otherSuite: string = '',
        public pathToPdf: string = '',
        public pdfName: string = '',
        public reportedArea: string = '',
        public reportedBy: string = '',
        public securityCompanyLogo: string = '',
        public incidentAt: string = '',
        public createdAt: string = '',
        public createdBy: string = '',
        public checked: boolean = false,
        public isCanEdit: boolean = true,
        public isCanDelete: boolean = true,
        public incidentReportTypeOther: any = '',
        public attachments: Array<any> = [],
        public entries: Array<any> = [],
        public formFields = {
            type: {editMode: false},
            reportedArea: {editMode: false},
            reportedBy: {editMode: false},
            incident: {editMode: false},
            building: {editMode: false},
            unit: {editMode: false},
            resident: {editMode: false},
            incidentAt: {editMode: false},
        }
    ) {
    }
}



// WEBPACK FOOTER //
// /app/src/app/types/models/IncidentReport.ts